import { FC } from 'react';

import { TooltipContentProps } from 'recharts';

type CustomLineChartTooltipProps = Partial<TooltipContentProps<number, string>>;
type CustomTrendChartTooltipProps = CustomLineChartTooltipProps & {
  valueSuffix?: string;
};

export const CustomTrendChartTooltip: FC<CustomTrendChartTooltipProps> = ({
  active,
  payload,
  label,
  valueSuffix = '',
}) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white outline outline-custom-warm-grey-200 rounded-[12px] shadow-custom-tooltip min-w-[180px] w-full">
      <div className="text-body-12-regular text-custom-warm-grey-700 px-3 py-2 border-b border-b-custom-warm-grey-200 flex items-center justify-between">
        <p>{label}</p>
      </div>
      <div className="flex flex-col gap-2 px-3 py-2 text-custom-warm-grey-700">
        {payload.map(item => {
          const value = item.value == null ? '' : String(item.value);
          return (
            <div className="flex items-center justify-between" key={item.name}>
              <p className="text-body-12-regular">{item.name}</p>
              <p className="text-body-12-semibold">{`${value}${valueSuffix}`}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
